export const PRODUCT_ACTIONS = {
    PRODUCT_SEARCH: 'PRODUCT_SEARCH',
    PRODUCT_SEARCH_SUCCESS: 'PRODUCT_SEARCH_SUCCESS',
    PRODUCT_SEARCH_ERROR: 'PRODUCT_SEARCH_ERROR',

    PRODUCT_UPSERT: 'PRODUCT_UPSERT',
    PRODUCT_UPSERT_SUCCESS: 'PRODUCT_UPSERT_SUCCESS',
    PRODUCT_UPSERT_ERROR: 'PRODUCT_UPSERT_ERROR',

    PRODUCT_EDIT: 'PRODUCT_EDIT',

    PRODUCT_RESET: 'PRODUCT_RESET',
};

export const productResetAction = () => ({
    type: PRODUCT_ACTIONS.PRODUCT_RESET,
});

export const productSearchAction = (payload) => ({
    type: PRODUCT_ACTIONS.PRODUCT_SEARCH,
    ...payload,
});

export const productEditAction = (payload) => ({
    type: PRODUCT_ACTIONS.PRODUCT_EDIT,
    ...payload,
});

export const productUpsertAction = (payload) => ({
    type: PRODUCT_ACTIONS.PRODUCT_UPSERT,
    ...payload,
});

export default {
    PRODUCT_ACTIONS,
    productSearchAction,
    productUpsertAction,
    productEditAction,
};
